<div class="container_width w-full flex flex-column gap-5 mx-auto">
  <h1 class="heading"><span>Essay <small>Pilot</small></span> </h1>

  <div class="flex flex-column md:flex-row w-full gap-5 md:gap-0">
    <div class="md:col-5 lg:col-4 col-12 p-0 md:pr-3 flex flex-column gap-4">
      <div class="flex flex-column gap-2">
        <p-button (click)="loadCommonEssay()" styleClass="essay_btn"
          class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
          <span>Common Essays</span>
          <i class="pi pi-angle-right"></i>
        </p-button>
        <p-button (click)="loadActivities()" styleClass="essay_btn"
          class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
          <span>Activities List</span>
          <i class="pi pi-angle-right"></i>
        </p-button>
        <p-button (click)="loadRecommendations()" styleClass="essay_btn"
          class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
          <span>Recommendation</span>
          <i class="pi pi-angle-right"></i>
        </p-button>
      </div>
      <div class="flex flex-column gap-3">
        <b class="text-xl font-bold">My Colleges</b>
        <div *ngFor="let institute of myInstitutes;" class="flex flex-column gap-2">
          <p-button styleClass="essay_btn" (click)="loadInstituteEssays(institute?.id??'')"
            class="flex align-items-center cursor-pointer justify-content-between font-normal text-base text-bluegray-700 hover:text-bluegray-900 active:text-bluegray-900 border-1 border-bluegray-300 border-round-lg bg-white hover:bg-bluegray-100 active:bg-bluegray-100">
            <span class="text-left">{{institute.instituteName}}</span>
            <i class="pi pi-angle-right"></i>
          </p-button>
        </div>
      </div>
      <div class="w-full mt-2">
        <a (click)="openAdditionalInfo()"
          class="add_inf cursor-pointer  w-full flex align-items-center justify-content-between py-3 px-4 border-round-lg text-left font-normal text-base"
          style=" color: #111111;">Task <i class="pi pi-angle-right"></i></a>
      </div>
    </div>
    <div *ngIf="currentSelectedTab===selectedTab.essaypilot" class="md:col-7 lg:col-8 col-12 p-0 md:pl-3">
      <div *ngIf="isLoading" class="flex gap-4 align-items-center justify-content-center py-5">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
          animationDuration=".5s" />
      </div>
      <div class="flex flex-column gap-4" *ngIf="currentPilotType === pilotType.common && !isLoading">
        <div class="flex flex-column gap-3 border-1 border-round-lg p-3 border-bluegray-200 bg-white">
          <b class="font-bold text-left text-xl">Essay pilot is here to help you navigate through the whirlwind of
            college essays.</b>
          <div class="flex flex-column gap-2">
            <p class="text-bluegray-700">1. Check the <strong class="text-bluegray-900">‘Common Essays’</strong> tab for
              a list of general essay requirements for your application.</p>
            <p class="text-bluegray-700">2. Scroll over to each college to view <strong
                class="text-bluegray-900">‘college specific’</strong> essay questions.</p>
            <p class="text-bluegray-700">3. Access your previously submitted drafts in the <strong
                class="text-bluegray-900">‘Past Submissions’</strong> section.</p>
          </div>
        </div>
        <app-essay-editor [essays]="commonEssays"></app-essay-editor>
      </div>
      <div class="flex flex-column gap-4" *ngIf="currentPilotType === pilotType.specific && !isLoading">
        <div class="flex flex-column gap-3 border-1 border-round-lg p-3 border-bluegray-200 bg-white">
          <b class="font-bold text-left text-xl">Essay pilot is here to help you navigate through the whirlwind of
            college essays.</b>
          <div class="flex flex-column gap-2">
            <p class="text-bluegray-700">1. Check the <strong class="text-bluegray-900">‘Common Essays’</strong> tab for
              a list of general essay requirements for your application.</p>
            <p class="text-bluegray-700">2. Scroll over to each college to view <strong
                class="text-bluegray-900">‘college specific’</strong> essay questions.</p>
            <p class="text-bluegray-700">3. Access your previously submitted drafts in the <strong
                class="text-bluegray-900">‘Past Submissions’</strong> section.</p>
          </div>
        </div>
        <app-institute-essay-editor *ngFor="let essay of essays; let i = index" [essay]="essay" [wordLimit]="questionsWordsLimits[i]"
          [instituteId]="instuteId??''"></app-institute-essay-editor>
      </div>

      <div class="flex flex flex-column gap-4" *ngIf="currentPilotType === pilotType.activities && !isLoading">
        <div class="flex flex-column gap-3 border-1 border-round-lg p-3 border-bluegray-200 bg-white">
          <b class="font-bold text-left text-xl">Essay pilot is here to help you navigate through the whirlwind of
            college essays.</b>
          <div class="flex flex-column gap-2">
            <p class="text-bluegray-700">1. Check the <strong class="text-bluegray-900">‘Common Essays’</strong> tab for
              a list of general essay requirements for your application.</p>
            <p class="text-bluegray-700">2. Scroll over to each college to view <strong
                class="text-bluegray-900">‘college specific’</strong> essay questions.</p>
            <p class="text-bluegray-700">3. Access your previously submitted drafts in the <strong
                class="text-bluegray-900">‘Past Submissions’</strong> section.</p>
          </div>
        </div>
        <app-activity-editor *ngFor="let activity of allActivityDetails?.result; let i = index" [activity]="activity"></app-activity-editor>
      </div>

      <div class="flex flex flex-column gap-4" *ngIf="currentPilotType === pilotType.recommendation && !isLoading">
        <div class="flex flex-column gap-3 border-1 border-round-lg p-3 border-bluegray-200 bg-white">
          <b class="font-bold text-left text-xl">Essay pilot is here to help you navigate through the whirlwind of
            college essays.</b>
          <div class="flex flex-column gap-2">
            <p class="text-bluegray-700">1. Check the <strong class="text-bluegray-900">‘Common Essays’</strong> tab for
              a list of general essay requirements for your application.</p>
            <p class="text-bluegray-700">2. Scroll over to each college to view <strong
                class="text-bluegray-900">‘college specific’</strong> essay questions.</p>
            <p class="text-bluegray-700">3. Access your previously submitted drafts in the <strong
                class="text-bluegray-900">‘Past Submissions’</strong> section.</p>
          </div>
        </div>
        <div class="flex flex-column gap-3 border-1 border-round-lg p-3 border-bluegray-200"
          style="background-color: #F9FBFD;">
          <b class="text-left font-bold text-xl">Write your letter of recommendation</b>
          <div class="w-full border-round-lg border-1 border-bluegray-200">
            <b
              class="w-full text-right block border-round-lg border-noround-bottom border-bottom-1 border-bluegray-200 py-2 px-3 bg-blue-50 text-bluegray-300 text-base font-normal">
              {{ wordCount }} / 650 words
            </b>
            <app-content-editor [htmlContent]="initialContent" (onContentChange)="onRecommendationChange($event)">
            </app-content-editor>
          </div>
          <small class="ng-dirty ng-invalid text-red-500" *ngIf="recommHtml.length==0 && isRecommSubmitted">
            Content is required
          </small>
          <!-- Submit Button -->
          <div class="w-full flex align-items-center justify-content-center">
            <p-button label="Send to Mentor" [loading]="isRecommendLoading" styleClass="sendMentor" type="button"
              (onClick)="onRecommendationSubmit()">
            </p-button>
          </div>
        </div>
      </div>
    </div>
    <!--Additional Information-->
    <app-additional-information class="md:col-7 lg:col-8 col-12 p-0 md:pl-3" *ngIf="currentSelectedTab === selectedTab.additionalInfo"
      [infoType]="additionalInfoType.EssayPilot">
    </app-additional-information>
  </div>
</div>
